import { Injectable } from '@angular/core';

@Injectable()
export class AppGlobals {
    public spa_id = '5fb647faa348a';
}
